import React from 'react'
import { useTranslation } from 'react-i18next'
import { ErrorBoundary, FallbackProps } from 'react-error-boundary'

import { ResidentAppError } from '../../../common/error'
import { ResidentAppErrorCode } from '../../../common/types'

import { Error } from 'components/Error'

interface ErrorHandlerProps {
  children: React.ReactNode
}

export const ErrorHandler: React.FC<ErrorHandlerProps> = ({ children }) => {
  const [t] = useTranslation(['documents'])

  const fallbackRender = ({ error }: FallbackProps) => {
    if (error instanceof ResidentAppError) {
      switch (error.errorCode) {
        case ResidentAppErrorCode.FILE_FAILED_TO_OPEN:
          return <Error message={t('errors.failedToOpen')} />

        default:
      }
    }

    return <Error message={t('errors.failedToLoad')} />
  }

  return (
    <ErrorBoundary fallbackRender={fallbackRender}>{children}</ErrorBoundary>
  )
}
